module.exports = __webpack_public_path__ + "img/logo-v_2027.d8207c8f.png";